import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import {
    Aangifte, AangifteRapport, BokkzAlgDataService,
    Box3InkomenUitSparenEnBeleggen,
    IncomeTaxEntity, LeningGeldVerstrekker,
    Rekening
} from '@snelstart-ventures/fiscaal/domain-logic';
import {FormArray, FormBuilder, FormGroup} from "@angular/forms";
import {BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import { SelectFormControlItem, SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import {optionsLandcodesMetNLD} from "../../gedeelde-componenten/gedeelde-componenten.component";
import { Event, NavigationEnd, Router } from "@angular/router";
import { filter, Subscription } from "rxjs";
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { CommonModule } from '@angular/common';
import { SharedUiAlertModule } from '@snelstart/ui-alert';
import { SharedUiDialogModule } from '@snelstart/ui-dialog';
import { SharedUiTooltipModule } from '@snelstart/ui-tooltip';
import { SharedUiPanelModule } from '@snelstart/ui-panel';
import { SharedUiIconModule } from '@snelstart/ui-icon';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-box3-beleggingsrekeningen',
  templateUrl: './box3-beleggingsrekeningen.component.html',
  styleUrls: ['./box3-beleggingsrekeningen.component.scss'],
    imports: [
        SharedUiFormControlsModule,
        SharedUiButtonModule,
        SharedUiDetailsModule,
        CommonModule,
        SharedUiAlertModule,
        SharedUiDialogModule,
        SharedUiTooltipModule,
        SharedUiPanelModule,
        SharedUiIconModule
    ]
})
export class Box3BeleggingsrekeningenComponent implements OnInit, OnDestroy {
    private routerSubscription: Subscription | undefined;
    private incomeTaxEntitySubscription: Subscription | undefined;
    private clientEntitySubscription: Subscription | undefined;
    private isSaving = false;
    @Input() public id!: string;
    public clientId!: string;
    public incomeTaxEntity = {} as IncomeTaxEntity;
    private focusedElementId: string | null = null;
    public dialogVisible = false;
    public index = 0;
    public jaar = 2024;
    heeftOWR: boolean[] = [];

    showDialog(index: number) {
        this.index = index;
        this.dialogVisible = true;
    }

    public optionsJaNee: SelectFormControlItem<boolean>[] = [
        {value: true, label: "Ja"},
        {value: false, label: "Nee"},
    ]

    public optionsLandcodes: SelectFormControlItem<string>[] = optionsLandcodesMetNLD;
    public beleggingsrekeningen = {} as FormGroup
    public labelJaar = '';
    public labelJaarEind = '';


    constructor(public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService,private router:Router, private fb: FormBuilder) {
        this.beleggingsrekeningen = this.fb.group({
            box3Beleggingen:
                this.fb.array<Box3InkomenUitSparenEnBeleggen>([])
        })
    }

    get box3Beleggingen(): FormArray {
        return this.beleggingsrekeningen.get('box3Beleggingen') as FormArray;
    }

    addRijBeleggingsrekeningen(): void {
        this.box3Beleggingen.push(this.createBeleggingenFormGroup()
        )
    }

    verwijderRijBeleggingsrekeningen(index: number): void {
        this.box3Beleggingen.removeAt(index);
        this.beleggingsrekeningen.updateValueAndValidity()
        this.beleggingsrekeningen.markAsDirty()
        this.saveForm()
    }



    createBeleggingenFormGroup(belegging?: Rekening): FormGroup {
        return this.fb.group(({
            omschrijving: belegging ? belegging.omschrijving : undefined,
            bedrag: belegging ? belegging.bedrag : undefined,
            rekeningNummer: belegging ? belegging.rekeningNummer : undefined,
            landCode: belegging ? belegging.landCode : 'NLD',
            groenRekening: belegging ? belegging.groenRekening : false,
            directRendement: belegging ? belegging.directRendement : undefined,
            valutaResultaat: belegging ? belegging.valutaResultaat : undefined,
            stortingen: belegging ? belegging.stortingen : undefined,
            onttrekkingen: belegging ? belegging.onttrekkingen : undefined,
            waardeEindJaar: belegging ? belegging.waardeEindJaar : undefined
        } as Rekening))
    }

    public ngOnInit(): void {
        this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
            this.incomeTaxEntity = incomeTaxEntity;
            if (incomeTaxEntity.aangifte) {
                this.updateForm();
                this.updateHeeftOWR();
                this.labelJaar = this.incomeTaxEntity.aangifte?.aangifteJaar ? `Waarde 1-1-${this.incomeTaxEntity.aangifte?.aangifteJaar}` : 'Waarde 1-1';
                this.labelJaarEind = this.incomeTaxEntity.aangifte?.aangifteJaar ? `Waarde 31-12-${this.incomeTaxEntity.aangifte?.aangifteJaar}` : 'Saldo 31-12';
            }
            if (incomeTaxEntity.year !== undefined) {
                this.jaar = incomeTaxEntity.year;
            }
        });
      this.clientEntitySubscription = this.dataAlgService.client.subscribe((client) =>{
        this.clientId=client.sstRelationId!;
      })
      this.routerSubscription = this.router.events
        .pipe(
          filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd))
        .subscribe((event: NavigationEnd) => {
          this.handleUrlChange(event.urlAfterRedirects);
        });
    }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe(); // Unsubscribe to avoid memory leaks
    }
    if (this.incomeTaxEntitySubscription) {
      this.incomeTaxEntitySubscription.unsubscribe();
    }
    if (this.clientEntitySubscription) {
      this.clientEntitySubscription.unsubscribe();
    }
  }

  handleUrlChange(newUrl: string) {
    if (!this.isSaving&& this.hasUnsavedChanges()) {
      this.isSaving = true;
      this.dataService.postIncomeTaxEntity(this.clientId,false, this.incomeTaxEntity);
      this.isSaving = false;
    }
  }

  private hasUnsavedChanges(): boolean {
    return this.beleggingsrekeningen.dirty
  }

    private updateForm(): void {
        const beleggingenLijst = this.incomeTaxEntity.aangifte?.box3?.beleggingsrekeningen || [];
        const formArray = this.beleggingsrekeningen.get('box3Beleggingen') as FormArray;
        const focusedControl = this.focusedElementId ? document.getElementById(this.focusedElementId) as HTMLElement : null;

        while (formArray.length > beleggingenLijst.length) {
            formArray.removeAt(formArray.length - 1);
        }

        // Add or update controls
        for (let i = 0; i < beleggingenLijst.length; i++) {
            if (i < formArray.length) {
                // Update existing control
                const control = formArray.at(i) as FormGroup;
                control.patchValue(beleggingenLijst[i]);
            } else {
                // Add new control
                const formGroup = this.createBeleggingenFormGroup(beleggingenLijst[i]);
                formArray.push(formGroup);
            }
        }

        if (focusedControl && document.contains(focusedControl)) {
            focusedControl.focus();
        }
    }

    saveForm(): void {
        this.incomeTaxEntity.aangifte = {
            ...this.incomeTaxEntity.aangifte,
            box3: {
                ...this.incomeTaxEntity?.aangifte?.box3,
                beleggingsrekeningen: this.beleggingsrekeningen.value.box3Beleggingen
            }
        } as Aangifte;
        this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);
        this.updateHeeftOWR();
    }

    protected readonly LeningGeldVerstrekker = LeningGeldVerstrekker;

    getOWRDialogTitel(i: number): string {
        const omschrijving = this.box3Beleggingen.controls[i]?.get('omschrijving')?.value;
        const rekeningnummer =this.box3Beleggingen.controls[i]?.get('rekeningNummer')?.value;
        const jaar = this.incomeTaxEntity.year;

        if (!omschrijving || !rekeningnummer) {
            return 'Werkelijk rendement belegging';
        }

        return `Werkelijk rendement: ${omschrijving} - ${rekeningnummer}`;
    }

    updateHeeftOWR(): void {
        this.heeftOWR = this.box3Beleggingen.controls.map((item) => {
            const velden = ['directRendement', 'waardeEindJaar', 'valutaResultaat', 'stortingen', 'onttrekkingen' ];

            return velden.some(veld => item?.get(veld)?.value);
        });
    }

    getBerekendeWerkelijkRendement(i: number): number | null {
        const control = this.box3Beleggingen.at(i);
        const bedrag = Number(control?.get('bedrag')?.value) || 0;
        const directRendement = Number(control?.get('directRendement')?.value) || 0;
        const valutaResultaat = Number(control?.get('valutaResultaat')?.value) || 0;
        const stortingen = Number(control?.get('stortingen')?.value) || 0;
        const onttrekkingen = Number(control?.get('onttrekkingen')?.value) || 0;
        const waardeEindJaar = Number(control?.get('waardeEindJaar')?.value) || 0;

        // Return null alle waarden leeg zijn
        if (!control?.get('directRendement')?.value && !control?.get('valutaResultaat')?.value &&
            !control?.get('bedrag')?.value && !control?.get('stortingen')?.value &&
            !control?.get('onttrekkingen')?.value && !control?.get('waardeEindJaar')?.value
        ) {
            return null;
        }

        return directRendement + valutaResultaat + waardeEindJaar - bedrag + onttrekkingen - stortingen;
    }

    getGroen(i: number): string {
        const control = this.box3Beleggingen.at(i);
        const isGroenRekening = control?.get('groenRekening')?.value || false;

        return isGroenRekening
            ? `(voor toepassen vrijstelling groene beleggingen)`
            : '';
    }

}
